import './functions';
import './variables';
import './statics';
import './logic';
import { wrapperBuilder } from './build';

export const EventTrackerWrapper = wrapperBuilder.build();
